// faq-tab-section (the FAQ page): category tabs, accordion questions, the
// mobile Filter toggle and the search box.
//
// The tabs and questions are real <button>s, so a keyboard can reach them and
// Enter and Space arrive here as clicks. They used to be <div>s with click
// listeners, which a keyboard could never reach (WCAG 2.1.1). Handlers are
// delegated from the document, so a section the theme editor re-renders keeps
// working.
(function () {
  if (window.__jiyuFaqTabs) return;
  window.__jiyuFaqTabs = true;

  // ARIA tabs: the selected tab is the only one in the Tab order.
  function selectTab(tab, moveFocus) {
    const faqSection = tab.closest(".faq-section");
    if (!faqSection) return;

    // The fallbacks by position cover a page Shopify cached before the tabs
    // and questions became buttons (no ids); this script serves it too.
    const panels = faqSection.querySelectorAll(".faq-category");
    faqSection.querySelectorAll(".faq-tab").forEach((t, i) => {
      const isActive = t === tab;
      t.classList.toggle("active", isActive);
      t.setAttribute("aria-selected", isActive ? "true" : "false");
      if (isActive) t.removeAttribute("tabindex");
      else t.setAttribute("tabindex", "-1");
      const panel = document.getElementById(t.getAttribute("aria-controls")) || panels[i];
      if (panel) panel.classList.toggle("active", isActive);
    });
    if (moveFocus) tab.focus();
  }

  function toggleQuestion(question) {
    const answer = document.getElementById(question.getAttribute("aria-controls")) || question.nextElementSibling;
    if (!answer) return;

    const open = question.getAttribute("aria-expanded") !== "true";
    question.classList.toggle("active", open);
    question.setAttribute("aria-expanded", open ? "true" : "false");
    answer.style.maxHeight = open ? answer.scrollHeight + "px" : "0px";
  }

  function toggleFilter(toggle) {
    const faqSection = toggle.closest(".faq-section");
    if (!faqSection) return;

    const isOpen = faqSection.classList.toggle("tabs-open");
    toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    toggle.textContent = isOpen ? "Close" : "Filter";
  }

  document.addEventListener("click", (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const tab = target.closest(".faq-section .faq-tab");
    if (tab) {
      selectTab(tab, false);
      return;
    }
    const question = target.closest(".faq-section .faq-question");
    if (question) {
      toggleQuestion(question);
      return;
    }
    const toggle = target.closest(".faq-section .faq-filter-toggle");
    if (toggle) toggleFilter(toggle);
  });

  // Up/Down arrows, Home and End move between the tabs (a vertical tablist).
  document.addEventListener("keydown", (event) => {
    if (event.altKey || event.ctrlKey || event.metaKey) return;
    const tab = event.target instanceof Element && event.target.closest(".faq-section .faq-tab");
    if (!tab) return;

    const tabs = Array.from(tab.closest(".faq-section").querySelectorAll(".faq-tab"));
    const i = tabs.indexOf(tab);
    let next = null;
    if (event.key === "ArrowDown") next = tabs[(i + 1) % tabs.length];
    else if (event.key === "ArrowUp") next = tabs[(i - 1 + tabs.length) % tabs.length];
    else if (event.key === "Home") next = tabs[0];
    else if (event.key === "End") next = tabs[tabs.length - 1];
    if (!next) return;

    event.preventDefault();
    selectTab(next, true);
  });

  // Search: filters the questions inside the active category only.
  document.addEventListener("input", (event) => {
    const input = event.target instanceof Element && event.target.closest(".faq-section .faq-search-input");
    if (!input) return;

    const activeCategory = input.closest(".faq-section").querySelector(".faq-category.active");
    if (!activeCategory) return;

    const query = input.value.toLowerCase().trim();
    activeCategory.querySelectorAll(".faq-item").forEach((item) => {
      if (query === "") {
        item.style.display = "block";
        return;
      }
      const q = (item.querySelector(".faq-question__text") || item.querySelector(".faq-question span")).textContent.toLowerCase();
      const a = item.querySelector(".faq-answer").textContent.toLowerCase();
      item.style.display = q.includes(query) || a.includes(query) ? "block" : "none";
    });
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  var answers = document.querySelectorAll(".faq-answer");

  answers.forEach(function (answer) {
    if (answer.dataset.emailsLinked === "true") return;

    var html = answer.innerHTML;

    html = html.replace(
      /(?![^<]*>)([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g,
      '<a href="mailto:$1">$1</a>'
    );

    answer.innerHTML = html;
    answer.dataset.emailsLinked = "true";
  });
});
